import styled from 'styled-components';

const SearchStyle = styled.div`
	--sContPaddingV: var(--sp13x);
	--sTitleMarginBottom: var(--sp4x);
	--sFiledMarginBottom: var(--sp6x);
	--sFieldMaxWidth: var(--sp86x);
	--sFieldPadding: var(--sp2-5x);
	--sCatContainerMarginBottom: var(--sp13x);
	--sCatItemMarginH: var(--sp1-5x);
	--sResultMarginBottom: var(--sp2-5x);
	--sItemInfoPadding: var(--sp4x);
	--sItemTitleMarginBottom: var(--sp4x);
	--sItemDescMarginBottom: var(--sp13x);
	--sItemTagMarginH: var(--sp1-5x);
	--sNoResultIconSize: var(--sp20x);
	--sNoResultIconMarginTop: var(--sp30x);
	--sNoResultIconMarginBottom: var(--sp7x);
	--sNoResultTitleMarginBottom: var(--sp5x);

	--newSearchGap: var(--sp1-5x);
	--searchClearWidth: 60px;

	padding: var(--sContPaddingV) 0;

	.s-title {
		margin-bottom: var(--sTitleMarginBottom);
	}

	.search-field-container {
		position: relative;
		max-width: var(--sFieldMaxWidth);
		margin-bottom: var(--sFiledMarginBottom);

		.search-field {
			.ant-input-wrapper {
				display: flex;

				input {
					font-size: 16px !important;
				}

				.ant-input-lg {
					font-size: var(--pS);
					font-weight: 500;
					padding: var(--sFieldPadding);
					line-height: 1;
				}

				.ant-input-group-addon {
					display: flex;
					font-size: var(--pS);
					width: auto;
					padding: 0;
					border: none;

					.ant-input-search-button {
						flex: 1;
						height: 100%;
						width: auto;
						padding: var(--sFieldPadding);

						svg {
							opacity: 1;
							transition: opacity var(--trTime);
							pointer-events: all;
							width: var(--pS);
							height: var(--pS);
						}
					}
				}
			}
		}

		.search-clear {
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			width: var(--searchClearWidth);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			pointer-events: none;
			transition: opacity var(--trTime);
		}

		&.disable-search-button {
			.search-field {
				.ant-input-wrapper {
					.ant-input-group-addon {
						.ant-input-search-button svg {
							opacity: 0;
							pointer-events: none;
						}
					}
				}
			}

			.search-clear {
				opacity: 1;
				pointer-events: all;
				cursor: pointer;
			}
		}

		&.new-version {
			.ant-input {
				border-radius: var(--sp0-5x) !important;
			}

			.ant-input-wrapper {
				gap: var(--newSearchGap) !important;
			}

			.ant-btn {
				display: flex !important;
				border-radius: var(--sp0-5x) !important;
			}

			.ant-btn-primary {
				color: var(--primaryColor1) !important;
				border-color: var(--secondaryColor3) !important;
				background: var(--secondaryColor3) !important;
				text-shadow: unset !important;
				box-shadow: unset !important;
			}

			.ant-input {
				border: unset !important;
				transition: unset !important;
				outline: unset !important;
			}

			.search-clear {
				color: var(--primaryColor1) !important;
				font-size: var(--p) !important;
			}

			.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
				left: 0 !important;
			}

			.ant-input-group-addon {
				transition: unset !important;
			}
		}
	}

	.search-cat-container {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(-1 * var(--sCatItemMarginH)) calc(var(--sCatContainerMarginBottom) - var(--sCatItemMarginH));

		.search-cat {
			margin: 0 var(--sCatItemMarginH) var(--sCatItemMarginH);
		}
	}

	.search-result-count {
		padding-bottom: var(--sResultMarginBottom);
		margin-bottom: var(--sResultMarginBottom);
		border-bottom: 1px solid var(--secondaryColor2);
	}

	.search-item-cont {
		margin: var(--colPadding) 0;
		display: flex;
		flex-direction: column;

		@media (hover: hover) {
			&:hover {
				.search-item {
					.search-item-image {
						overflow: hidden;
						span {
							img {
								transform: scale(1.3);
							}
						}
					}
				}
			}
		}

		.imageCont {
			--imagePaddingTop: 62.25%;
		}

		.link-item {
			height: 100%;
		}

		.search-item {
			border-radius: var(--sp2x);
			overflow: hidden;
			display: flex;
			flex-direction: column;
			height: 100%;

			.search-info-cont {
				padding: var(--sItemInfoPadding);
				display: flex;
				flex-direction: column;
				flex: 1;

				.search-item-title {
					margin-bottom: var(--sItemTitleMarginBottom);
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.search-item-desc {
					margin-bottom: var(--sItemDescMarginBottom);
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.search-item-tags {
					display: flex;
					flex-wrap: wrap;
					overflow: hidden;
					margin: 0 calc(-1 * var(--sItemTagMarginH));

					.search-item-tag {
						margin: var(--sItemTagMarginH);
						white-space: nowrap;
					}
				}
			}
		}
	}

	.no-result-cont {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		& + {
			.search-load-more-wrap {
				display: none;
			}
		}

		.no-result-icon {
			display: inline-flex;
			margin-top: var(--sNoResultIconMarginTop);
			margin-bottom: var(--sNoResultIconMarginBottom);
			font-size: var(--sNoResultIconSize);
		}

		.no-result-title {
			margin-bottom: var(--sNoResultTitleMarginBottom);
		}
	}

	.search-load-more-wrap {
		display: flex;
		justify-content: center;

		.search-load-more {
			width: fit-content;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--sContPaddingV: var(--sp10x);
		--sTitleMarginBottom: var(--sp3x);
		--sFiledMarginBottom: var(--sp5x);
		--sFieldMaxWidth: var(--sp64x);
		--sFieldPadding: var(--sp2x);
		--sCatContainerMarginBottom: var(--sp10x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp2x);
		--sItemInfoPadding: var(--sp3x);
		--sItemTitleMarginBottom: var(--sp2x);
		--sItemDescMarginBottom: var(--sp10x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp15x);
		--sNoResultIconMarginTop: var(--sp21x);
		--sNoResultIconMarginBottom: var(--sp4x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 52px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--sContPaddingV: var(--sp8x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: var(--sp50x);
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp8x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp8x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp12x);
		--sNoResultIconMarginTop: var(--sp22x);
		--sNoResultIconMarginBottom: var(--sp3x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--sContPaddingV: var(--sp8x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: var(--sp48x);
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp8x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp8x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp12x);
		--sNoResultIconMarginTop: var(--sp16x);
		--sNoResultIconMarginBottom: var(--sp3x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--sContPaddingV: var(--sp7x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: var(--sp48x);
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp7x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp7x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp12x);
		--sNoResultIconMarginTop: var(--sp17x);
		--sNoResultIconMarginBottom: var(--sp3x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--sContPaddingV: var(--sp5x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: var(--sp40x);
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp5x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp6x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp20x);
		--sNoResultIconMarginTop: var(--sp19x);
		--sNoResultIconMarginBottom: var(--sp3x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--sContPaddingV: var(--sp5x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: var(--sp39x);
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp5x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp6x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp12x);
		--sNoResultIconMarginTop: var(--sp34x);
		--sNoResultIconMarginBottom: var(--sp3x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--sContPaddingV: var(--sp5x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: 100%;
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp5x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp6x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp10x);
		--sNoResultIconMarginTop: var(--sp27x);
		--sNoResultIconMarginBottom: var(--sp2-5x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--sContPaddingV: var(--sp5x);
		--sTitleMarginBottom: var(--sp2-5x);
		--sFiledMarginBottom: var(--sp4x);
		--sFieldMaxWidth: 100%;
		--sFieldPadding: var(--sp1-5x);
		--sCatContainerMarginBottom: var(--sp5x);
		--sCatItemMarginH: var(--sp1x);
		--sResultMarginBottom: var(--sp1-5x);
		--sItemInfoPadding: var(--sp2-5x);
		--sItemTitleMarginBottom: var(--sp2-5x);
		--sItemDescMarginBottom: var(--sp6x);
		--sItemTagMarginH: var(--sp1x);
		--sNoResultIconSize: var(--sp10x);
		--sNoResultIconMarginTop: var(--sp27x);
		--sNoResultIconMarginBottom: var(--sp2-5x);
		--sNoResultTitleMarginBottom: var(--sp3x);

		--newSearchGap: var(--sp1x);
		--searchClearWidth: 44px;

		.search-field {
			.ant-input-wrapper {
				.ant-input {
					font-size: 16px;
				}
			}
		}
	}
`;

export default SearchStyle;
